import './scss/main.scss';
import './ts/accessibility';

import { debugMode } from "@/ts/utilities";
import { DEBUG_MODE } from "@/ts/enums";
import { initDataModels } from "@reactive/lib";
import { Components } from "@/fragments/components";

debugMode(DEBUG_MODE.NOTICE);
document.addEventListener("DOMContentLoaded", () => {
    initDataModels()
    Components();
});